import { getEmailDraftId } from '../../Email.utils'
import { useEmailGetActiveAccountForCreate } from '../useEmailGetActiveAccountForCreate'

export function useEmailDraftId(prefix) {
  const { activeAccountForCreate } = useEmailGetActiveAccountForCreate()

  return activeAccountForCreate ? getEmailDraftId(prefix) : null
}
